// *******************************************************************************
// Form handling
// *******************************************************************************

const getPhoneLengthError = (formElement) =>
  formElement?.querySelector('[name="telephone"]')?.getAttribute('data-fv-phone-length__message') || '';

const handleForm = (form, formAction) => {
  const formParent = form.closest('[data-parent]');
  const formAlertError = formParent.querySelector('.form-component__alert-error');
  const passwordField = document.getElementById('setPassword');
  const phoneLengthError = getPhoneLengthError(form);
  const preloadRecaptcha = () => {
    loadRecaptcha().catch(() => {});
  };

  ['focusin', 'input', 'pointerdown'].forEach((eventName) => {
    form.addEventListener(eventName, preloadRecaptcha, { once: true });
  });

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {
      telephone: {
        validators: {
          stringLength: {
            min: 9,
            max: 15,
            message: phoneLengthError,
          },
        },
      },
    },

    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) =>
          element.closest('.mod-input,.checkbox,.dropdown,.radio-button,.upload-box__main'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .on('core.element.validated', (e) => {
      if (e.element.hasAttribute('required')) {
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(
          e.element,
          '.mod-input, .checkbox, .dropdown, .radio-button, .upload-box__main',
        );
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '' || !e.valid,
        });
      }
    })
    .on('core.form.valid', async () => {
      formParent.classList.add('show-loader');
      try {
        await loadRecaptcha();

        if (form.id === 'inquiry-form') {
          const basket = document.querySelector('.product-basket');
          if (basket) {
            basket.classList.remove('is-active');
          }
        }
        let requiredInputs = '';
        form.querySelectorAll('.form-component__inner input, .form-component__inner textarea').forEach((input) => {
          if (input.type !== 'hidden' && input.hasAttribute('required')) {
            requiredInputs += `${input.name}|`;
          }
        });
        requiredInputs = requiredInputs.slice(0, -1);

        const response = await onFormSubmit({
          formData: {
            ...getFormValue(form, fv),
            product: localData?.product_event ?? '',
            id: localData.id,
            product_id: localData.id,
            lang: localData.lang,
            form_id: form.id,
            requiredInputs,
            localData: localData && ['save-score-form'].includes(form.id) ? JSON.stringify(localData) : '',
          },
          recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
          recaptchaAction: formAction,
        });
        if (response.data.data.data_layer) {
          dataLayerSend(response.data.data.data_layer);
        }
        if (form.id === 'save-score-form' && response.data.data.html) {
          const { html } = response.data.data;
          document.querySelector('#leaderboard-wrap table tbody').innerHTML = html;
          document.querySelector('#screen-start table tbody').innerHTML = html;
        }

        if (response.data.data.html_cart) {
          const cart = document.querySelector('.cart-box');
          cart.innerHTML = response.data.data.html_cart;
          initBasket();
          setTimeout(() => {
            cart.querySelector('.product-basket').classList.add('is-active');
          }, 200);
          formParent.querySelector('.form-component__alert.form-component__alert-success').classList.remove('hide');
        }

        formParent.classList.remove('show-loader');
        formParent.classList.add('show-thankyou');
        if (formParent.closest('.form-modal')) {
          const formModalEle = formParent.closest('.form-modal');
          formModalEle.classList.add('show-thankyou');
        }
      } catch (error) {
        console.error(error);
        formParent.classList.remove('show-loader');
        formParent.classList.add('show-error');
        formAlertError.classList.remove('hide');
        formAlertError.innerHTML = error?.response?.data?.data?.msg || 'reCAPTCHA failed to load.';
      }
    });

  if (passwordField) {
    const getValidationElem = (parent, selector) => parent.querySelector(selector);
    const passwordFieldParent = passwordField.closest('.mod-input');
    const [notEmptyMsg, capitalLettersMsg, lowerCaseMsg, digitMsg, minCharactersMsg, specialCharacter] = [
      '[data-fv-not-empty___message]',
      '[data-password-capital-letters]',
      '[data-password-lowercase]',
      '[data-password-digit]',
      '[data-password-min-characters]',
      '[data-password-special-character]',
    ].map((query) => getValidationElem(passwordFieldParent, query));
    const allValidationItems = passwordFieldParent.querySelectorAll('.mod-input__password-validation-item');
    const confirmPassValidationElem = document.getElementById('confirmResetPassword');

    const toggleValidationClass = (elem, toggle) => {
      passwordField.closest('.mod-input').classList.toggle('is-validation-failed', toggle);
      elem.classList.toggle('is-failed', toggle);
      elem.classList.toggle('is-passed', !toggle);
    };

    const strongPassword = () => ({
      // eslint-disable-next-line consistent-return
      validate(input) {
        const password = input.value;
        const lowercaseRegex = /[a-z]/;
        const uppercaseRegex = /[A-Z]/;
        const numberRegex = /\d/;
        const specialCharRegex = /[!@#$%^&*()_\-+=<>?]/;
        let isValid = true;

        if (password === '') {
          isValid = false;
          allValidationItems.forEach((elem) => {
            elem.classList.remove('is-failed');
            elem.classList.remove('is-passed');
          });
          passwordField.closest('.mod-input').classList.remove('is-validation-failed');
        }

        [
          {
            validator: !uppercaseRegex.test(password),
            element: capitalLettersMsg,
          },
          {
            validator: !lowercaseRegex.test(password),
            element: lowerCaseMsg,
          },
          {
            validator: !numberRegex.test(password),
            element: digitMsg,
          },
          {
            validator: !specialCharRegex.test(password),
            element: specialCharacter,
          },
          {
            validator: password.length < 8,
            element: minCharactersMsg,
          },
        ].forEach(({ validator, element }) => {
          if (validator) {
            isValid = false;
          }

          toggleValidationClass(element, validator);
        });

        if (isValid) {
          return {
            valid: true,
          };
        }
      },
    });

    const setPasswordValidators = {
      validators: {
        notEmpty: {
          message: notEmptyMsg.getAttribute('data-fv-not-empty___message'),
        },
        // checkPassword is name of new validator
        checkPassword: {
          message: notEmptyMsg.getAttribute('data-fv-not-empty___message'),
        },
      },
    };

    if (confirmPassValidationElem) {
      const confirmPassValidationMsg = confirmPassValidationElem.getAttribute('data-fv-identical___message');

      const confirmResetPasswordValidators = {
        validators: {
          identical: {
            compare() {
              return form.querySelector('[name="setPassword"]').value;
            },
            message: confirmPassValidationElem ? confirmPassValidationMsg : '',
          },
        },
      };

      fv.addField('confirmResetPassword', confirmResetPasswordValidators);
    }

    fv.addField('setPassword', setPasswordValidators);

    fv.registerValidator('checkPassword', strongPassword);

    // Validate password on password type
    const validateField = (setPassword) => {
      const field = fv.getFields(setPassword);
      if (field) {
        fv.validateField(setPassword);
      }
    };

    passwordField.addEventListener('input', () => {
      const fieldName = 'setPassword';
      validateField(fieldName);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  [
    'form-module',
    'newsletter-form',
    'newsletter-form-footer',
    'inquiry-form',
    'giveaway-form',
    'friend-form',
    'save-score-form',
    'leaderboard-form',
  ].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      handleForm(form, formAction);
    }
  });
  document.body.addEventListener('click', (event) => {
    const { target } = event;
    if (target.name === 'region') {
      const element = document.querySelector('[name="points-of-sale"]');
      if (element) {
        const parent = element.closest('.is-disabled');
        if (parent) {
          parent.classList.remove('is-disabled');
        }
      }
      const selectedPoints = target.dataset.points ? target.dataset.points.split('|') : [];
      document.querySelectorAll('input[name="points-of-sale"]').forEach((input) => {
        const isHidden = !selectedPoints.includes(input.value);
        input.closest('.dropdown__list-item').classList.toggle('is-hidden', isHidden);
        if (isHidden && input.checked) {
          input.checked = false;
          const placeholderText = input
            .closest('.form-component__row-item')
            ?.querySelector('.dropdown__placeholder-text');
          if (placeholderText) {
            placeholderText.innerHTML = '';
          }
        }
      });
    }
    if (target.name === 'points-of-sale') {
      const selectedRegion = target.dataset.region;
      const matchingRegion = document.querySelector(`input[name="region"][value="${selectedRegion}"]`);
      if (matchingRegion) {
        matchingRegion.closest('li').querySelector('label').click();
      }
    }
  });
});

const applyInputFilter = (selector, regex, replace) => {
  document.querySelectorAll(selector).forEach((input) => {
    input.addEventListener('input', () => {
      input.value = input.value.replace(regex, replace);
    });
  });
};

applyInputFilter('input[name="telephone"]', /[^0-9]/g, '');
applyInputFilter('input[name="name"]', /[^\p{L}\s'-]/gu, '');
